<template>
  <!-- 統一容器包裹 -->
  <div class="navbar-container content-container">
    <div class="navbar">
      <div class="left-menu">
        <template>
          <div class="nav-brand">
            <img src="@/assets/home/logo-蓝色.png" class="logo-image" />
          </div>
        </template>
      </div>

      <div class="right-menu">
        <template v-if="device !== 'mobile'">
          <el-menu
            mode="horizontal"
            background-color="#ffffff"
            text-color="#333333"
            active-text-color="#409EFF"
            class="main-menu"
            :default-active="activeIndex"
            @select="handleMenuSelect"
          >
            <!-- 基础资料管理 v-if="hasBasicDataPermission()"-->
            <el-submenu index="basicDataManagment" popper-class="nav-submenu" v-if="hasBasicDataPermission()">
              <template slot="title">
                <b> {{ $t("TurboInfo.basicDataManagment") }}</b>
              </template>
              <el-menu-item index="industry" @click="navigateTo('/BasicDataManagment/IndustryManagment')">
                {{ $t("TurboInfo.industryManagment") }}
              </el-menu-item>
              <el-menu-item index="industrySolutions" @click="navigateTo('/BasicDataManagment/IndustrySolutionsManagment')">
                {{ $t("TurboInfo.industrySolutionsManagment") }}
              </el-menu-item>
              <el-menu-item index="technology" @click="navigateTo('/BasicDataManagment/CoreTechnology')">
                {{ $t("TurboInfo.technologyManagement") }}
              </el-menu-item>
              <el-menu-item index="technologyMode" @click="navigateTo('/BasicDataManagment/CoreTechnologyMode')">
                {{ $t("TurboInfo.technologyModeManagement") }}
              </el-menu-item>
              <el-menu-item index="technologyDetail" @click="navigateTo('/BasicDataManagment/CoreTechnologyDetail')">
                {{ $t("TurboInfo.technologyDetailManagement") }}
              </el-menu-item>
              <!-- <el-menu-item index="SGMindustry" @click="navigateTo('/BasicDataManagment/SGMIndustryManagment')">
                {{ $t("TurboInfo.sgmindustryManagment") }}
              </el-menu-item>
              <el-menu-item index="SGMindustrySolutions" @click="navigateTo('/BasicDataManagment/SGMIndustrySolutionsManagment')">
                {{ $t("TurboInfo.sgmindustrySolutionsManagment") }}
              </el-menu-item> -->
            </el-submenu>
            
            <!-- 权限管理菜单 v-if="hasBasicDataPermission()"-->
            <el-submenu index="download" popper-class="nav-submenu" v-if="hasBasicDataPermission()">
              <template slot="title">
                <b> {{ $t("TurboInfo.authorityManagment") }}</b>
              </template>
              <el-menu-item index="user" @click="navigateTo('/Authority/user')">
                {{ $t("TurboInfo.userManagement") }}
              </el-menu-item>
              <el-menu-item index="userAuthority" @click="navigateTo('/Authority/userAuthority')">
                {{ $t("TurboInfo.userAuthority") }}
              </el-menu-item>
              <el-menu-item index="userLeaveMessage" @click="navigateTo('/Authority/userLeaveMessage')">
                {{ $t("TurboInfo.LeaveMessage") }}
              </el-menu-item>

              <div class="menu-divider"></div>

              <el-menu-item index="userImport" @click="navigateTo('/Authority/userImport')">
                {{ $t("TurboInfo.userImport") }}
              </el-menu-item>
              <el-menu-item index="AuthorityLevel" @click="navigateTo('/Authority/authorityLevel')">
                {{ $t("TurboInfo.authorityLevel") }}
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="Home" @click="navigateTo('/')">
              <b>Turbo首页</b>
            </el-menu-item>

            <el-menu-item index="DIAStudio" @click="navigateTo('https://diastudio.deltaww.com/Home')">
              <b>DIAStudio</b>
            </el-menu-item>

            <template>
              <el-menu-item index="login" @click="login" v-if="userName == null">
                <b>{{ $t("TurboInfo.login") }}</b>
              </el-menu-item>

              <!-- 用户菜单 -->
              <el-submenu v-else index="user-menu" popper-class="nav-submenu">
                <template slot="title">
                  <b>{{ userName }}</b>
                </template>
                
                <el-menu-item index="logout" @click="handleLogout">
                  <i class="el-icon-switch-button"></i>
                  {{ $t("TurboInfo.loginOut") }}
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </template>
      </div>

      <div class="color-bar" v-show="isOtherPage">
        <span class="color1"> </span>
        <span class="color2"> </span>
        <span class="color3"> </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import LangSelect from "@/components/LangSelect";
import ThemePicker from "@/components/ThemePicker";
import Theme from "@/components/Theme";
import { setToken, AuthService } from "@/utils/auth";
import { getuserauthorities, GetAuthorities, getusers, Operateuser, OperateUserauthority, GetDiauser } from "@/api/user";

export default {
  props: {},
  data() {
    return {
      activeIndex: "home",
      authService: new AuthService(),
      userName: null,
      userDataName: "",
      isOtherPage: false,
      userauthorities: [],
      userId: "",
    };
  },
  
  components: {
    LangSelect,
    ThemePicker,
    Theme,
  },
  
  computed: {
    ...mapGetters(["avatar", "device"]),
  },

  mounted() {
    this.userName = sessionStorage.getItem("name");
    this.userDataName = sessionStorage.getItem("lastName") + sessionStorage.getItem("firstName");
    
    if (this.userName) {
      this.Getuserauthorities('');
    }
  },
  
  watch: {
    userName: {
      async handler(newVal, oldVal) {
        console.log("currentUser 发生了变化:", {
          旧值: oldVal,
          新值: newVal,
        });
        
        if (newVal) {
          await this.checkAndAddUser(newVal);
          await this.Getuserauthorities('');
          
          const userIsInList = await getusers({ name: newVal });
          if(userIsInList){
            const getUserInfo = userIsInList.data.data.items[0];
            const user_cast = this.userauthorities.find(item => item.userId === getUserInfo.id);
            const userExists = Boolean(user_cast);
            
            if (!userExists) {
              console.log("新用户登入，添加到权限清单");
              await this.addUserToAuthorityList();
              await this.Getuserauthorities('');
            }
          }
        } else {
          this.userAuthorities = [];
        }
      },
      deep: true,
    },

    $route: {
      immediate: true,
      handler(route) {
        this.setColorBar();
      },
    },
  },
  
  methods: {
    async checkAndAddUser(userName) {
      const userId = sessionStorage.getItem("userId");
      
      if (!userId) {
        console.log("未找到userId，跳过用户添加");
        return;
      } else {
        this.userId = userId;
      }
      
      try {
        const userIsInList = await getusers({ name: userName });
        
        if (userIsInList.data.data.items.length === 0 && userId) {
          const getUserResponse = await GetDiauser(userId);
          
          if (getUserResponse) {
            const getNewUserData = getUserResponse.data.data.items[0];
            const userInfo = {
              id: "",
              createBy: "",
              createDate: null,
              name: userName,
              firstName: getNewUserData.FirstName,
              lastName: getNewUserData.LastName,
              email: getNewUserData.Email,
              role: 0,
              phoneNumber: "",
              companyName: "",
              industry: "",
              country: "",
              city: "",
              description: "",
              level: 0,
              operate: 1
            };
            console.log("新增用户:", userInfo);
            const result = await Operateuser(userInfo);
          }
        }
      } catch (error) {
        console.error("添加用户时发生错误:", error);
      }
    },
    
    async addUserToAuthorityList() {
      try {
        const userList = await getusers({ name: this.userName });
        
        if (!userList.data.data.items || userList.data.items.length === 0) {
          console.log("用户不存在于用户列表中");
          return false;
        }
        
        const getUserInfo = userList.data.data.items[0];
        const authResponse = await GetAuthorities();
        const authoritiesList = authResponse?.data?.data?.items || [];
        const getAuthority = authoritiesList.find(item => item.level === 1);
        
        if (!getAuthority) {
          console.log("未找到 level=1 的权限");
          return false;
        }
        
        const userAuthorityInfo = {
          id: "",
          userId: getUserInfo.id,
          userName: this.userName,
          authorityId: getAuthority.id,
          authorityLevel: 1,
          authorityName: getAuthority.name,
          createBy: "",
          LastUpdateBy: "",
          createDate: null,
          operate: 1,
        };
        
        //console.log("準備添加用戶權限:", userAuthorityInfo);
        const result = await OperateUserauthority(userAuthorityInfo);
        //console.log("用戶權限添加結果:", result);
        return true;
      } catch (error) {
        console.error("添加用户权限失败:", error);
        return false;
      }
    },
    
    login() {
      const authService = new AuthService();
      authService.login();
    },
    
    handleLogout() {
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("name");
      this.userName = null;
      const authService = new AuthService();
      authService.logout();
    },
    
    navigateTo(path) {
      if (path.includes("http")) {
        //window.open(path, "_blank");
        window.location.href = path;
      } else {
        if (this.$route.path == "/home" && path == "/") {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          if (this.$route.path != path) {
            this.$router.push(path);
          } else {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }
        }
      }
    },
    
    handleMenuSelect(index, indexPath) {
      this.activeIndex = index;
    },
    
    setColorBar() {
      if (this.$route.path == "/home") {
        this.isOtherPage = false;
      } else {
        this.isOtherPage = true;
      }
    },
    
    Getuserauthorities(formData) {
      getuserauthorities(formData).then((res) => {
        if (res.status === 200) {
          this.userauthorities = res.data.data.items;
        }
      });
    },
    
    hasBasicDataPermission() {
      if (!this.userName || !Array.isArray(this.userauthorities)) {
        return false;
      }
      
      const normalizedUserName = this.userName.replace(/\s+/g, '');
      
      const userAuthority = this.userauthorities.find(item => {
        if (!item.userName) return false;
        
        const normalizedItemName = item.userName.replace(/\s+/g, '');
        
        if (normalizedUserName === normalizedItemName) return true;
        
        if (normalizedUserName.length === 3 && normalizedItemName.length === 3) {
          const name1 = normalizedItemName.substring(1) + normalizedItemName[0];
          const name2 = normalizedItemName[2] + normalizedItemName.substring(0, 2);
          return normalizedUserName === name1 || normalizedUserName === name2;
        }
        
        return false;
      });
      
      return userAuthority && userAuthority.authorityLevel === 0;
    },
  },
  
  created() {
  },
};
</script>

<style scoped>
/* 統一容器樣式 - 與其他頁面元素保持一致 */
.navbar-container {
  max-width: 1200px; /* 與頁面內容最大寬度一致 */
  margin: 0 auto;     /* 水平居中 */
  padding: 0 10px;    /* 統一的左右邊距 */
  width: 100%;        /* 佔滿父容器 */
  box-sizing: border-box; /* 確保padding不影響總寬度 */
  background-color: #fff; /* 保持背景色一致 */
  position: relative;
  z-index: 1000;      /* 確保在最上層 */
}

/* 導航欄主體 */
.navbar {
  color: #328bf0;
  position: relative; /* 從fixed改為relative，由容器控制定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;       /* 保持原有高度 */
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 左側菜單區域 */
.left-menu {
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;     /* 防止被壓縮 */
}

/* Logo圖像 */
.logo-image {
  object-fit: contain;
  border-radius: 4px;
  width: 120px;
  height: 50px;
  margin-left: 0;     /* 移除左邊距，由容器padding控制 */
  margin-top: 5px;
}

/* 右側菜單區域 */
.right-menu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;       /* 佔據剩餘空間 */
  height: 100%;
}

/* 主菜單樣式 */
.main-menu {
  border-bottom: none;
  display: flex;
  justify-content: center;
  height: 100%;
  background-color: transparent;
}

.main-menu .el-menu-item,
.main-menu .el-submenu__title {
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
}

.main-menu .el-menu-item:hover,
.main-menu .el-submenu__title:hover {
  background-color: #f5f7fa;
  border-bottom-color: #409EFF;
  color: #409EFF;
}

.main-menu .el-menu-item.is-active {
  border-bottom-color: #409EFF;
  background-color: transparent;
  color: #409EFF;
}

/* 彩色裝飾條 */
/* .color-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 7px;
  display: flex;
  pointer-events: none; /* 防止干擾點擊 */
/* } */ 

.color-bar {
  position: absolute;
  bottom: 0;
  left: 50%; /* 居中定位 */
  transform: translateX(-50%); /* 居中對齊 */
  width: 100vw; /* 視口寬度 */
  max-width: 100vw; /* 確保不超過視口 */
  height: 7px;
  display: flex;
  pointer-events: none;
  z-index: 999;
}

.color-bar .color1 {
  background: #0087dc;
  width: 60%;
}

.color-bar .color2 {
  background: #64d7d7;
  width: 20%;
}

.color-bar .color3 {
  background: #b9eb5f;
  width: 20%;
}

/* 菜單分隔線 */
.menu-divider {
  height: 1px;
  background-color: #dcdfe6;
  margin: 6px 0;
  transform: translateX(-2px);
  border: none;
}

/* 響應式設計 */
@media (max-width: 1200px) {
  .navbar-container {
    max-width: 100%; /* 在較小屏幕上佔滿寬度 */
  }
}

@media (max-width: 992px) {
  .navbar-container {
    padding: 0 15px; /* 中等屏幕減少邊距 */
  }
  
  .main-menu .el-menu-item,
  .main-menu .el-submenu__title {
    padding: 0 12px;
    font-size: 13px;
  }
  
  .logo-image {
    width: 100px;
    height: 40px;
  }
}

@media (max-width: 768px) {
  .navbar-container {
    padding: 0 10px; /* 小屏幕進一步減少邊距 */
  }
  
  .main-menu {
    display: none; /* 移動端隱藏主菜單，顯示漢堡菜單 */
  }
  
  .logo-image {
    width: 90px;
    height: 35px;
  }
  
  /* 可以添加移動端菜單按鈕 */
  .mobile-menu-btn {
    display: block;
    background: none;
    border: none;
    font-size: 24px;
    color: #333;
    cursor: pointer;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    padding: 0 8px; /* 最小屏幕最小邊距 */
  }
  
  .logo-image {
    width: 80px;
    height: 30px;
  }
}
</style>
